/**
 * Progress for a lazily-downloaded bundled server binary. Shared so the
 * renderer can render a real progress bar without importing main-process code.
 */

export type RuntimeDownloadPhase =
  | 'downloading'
  | 'verifying'
  | 'installed'
  | 'failed';

export interface RuntimeDownloadProgress {
  /** Product-facing bundled server id (`outlook-local`), not the upstream binary name. */
  serverId: string;
  phase: RuntimeDownloadPhase;
  receivedBytes: number;
  /** Absent when the CDN response carries no Content-Length. */
  totalBytes?: number;
}

export const RUNTIME_DOWNLOAD_PROGRESS_CHANNEL = 'axon-mcp:download-progress';

export const SETUP_PROGRESS_CHANNEL = 'axon-mcp:setup-progress';
export const DEVICE_CODE_PROMPT_CHANNEL = 'axon-mcp:device-code-prompt';
